export const getHeaderSP = (selected, deductions) => {
  const { payrollTypes, jobTypeVal, payItems } = selected;
  const { incentives, otherInfo } = deductions;

  const additionalHeader = incentives.flatMap((item) =>
    item?.otherAdditionals.map((allowance) => ({ label: allowance?.name }))
  );
  const deductionHeader = incentives.flatMap((item) =>
    item?.otherDeductions.map((allowance) => ({ label: allowance?.name }))
  );

  const allowanceName = payrollTypes === "SP" ? payItems : "";

  const commonHeaders = [
    { label: "Employee Number" },
    { label: "ACCT NO." },
    { label: "LN" },
    { label: "FN" },
    { label: "MN" },
  ];

  if (payItems === "20% Monthly Premium") {
    return [
      [
        { label: "#" },
        ...commonHeaders,
        { label: "EARNED FOR THE PERIOD" },
        ...(otherInfo?.monthTo !== ""
          ? [{ label: "EARNED FOR THE PERIOD" }]
          : []),
        { label: "TOTAL EARNED" },
        { label: "20% EARNED AMOUNT" },
        { label: "3%" },
        { label: "NET PAY" },
      ],
      [],
    ];
  }

  const headerMap = {
    [payItems]: [
      { label: "#" },
      ...commonHeaders,
      ...additionalHeader,
      ...deductionHeader,
      { label: "NET PAY" },
    ],
    DEFAULT: [...commonHeaders],
  };

  if (allowanceName in headerMap) {
    return [headerMap[allowanceName], []];
  } else {
    return [[], [], []];
  }
};
